import { render, staticRenderFns } from "./ProfilerUserView.vue?vue&type=template&id=630d2a6b&scoped=true"
import script from "./ProfilerUserView.vue?vue&type=script&lang=js"
export * from "./ProfilerUserView.vue?vue&type=script&lang=js"
import style0 from "./ProfilerUserView.vue?vue&type=style&index=0&id=630d2a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d2a6b",
  null
  
)

export default component.exports